import React from "react";
import { connect } from "react-redux";
import { message, Modal, Form, Button,Input } from 'antd';
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import dailyReportrexceptionDtatisticsService from "../../services/WorkReport/daily-reportrexception-statistics-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';

export default class NoDeliveryWeeklyReport extends ReactAbstract {



    initReload = false
    dataMode = 0
    deleteRowSelection = false
    moduleName = "approval"
    childModuleName = "dailyReportrexceptionStatistics"
    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "loaded",
        currentDataFilters: {},
        filters: {
            start_time: null,
            end_time: null,
            status:-1
        },
        data: [],
        dataStatus: "loaded",

    }
    actions = {
        selectAction: dailyReportrexceptionDtatisticsService.fetchNoDeliveryWeeklyReportList,
        updateAction: dailyReportrexceptionDtatisticsService.updateHRWorkReportExceptionStatistics,
        exportAction: dailyReportrexceptionDtatisticsService.exportNoDeliveryWeeklyReportList,
    }
    headerColumn = [{
        title: "导出",
        access: "export_value",
        icon: "cloud-download-o",
        click: this.publicExport
    }
    ]
    filterColumn = [
        {
            type: "department"
        }, {
            type: "selectValue",
            label: "未交类型",
            key: "status",
            defaultValue:1,
            children: [{
                text: "全部",
                id: -1
            }, {
                text: "未交",
                id: 1
            }, {
                text: "晚交",
                id: 2
            }]
        }, {
            type: "date",
            label: "结束时间",
            key: "search_end_time",
        }, {
            type: "date",
            label: "开始时间",
            key: "search_start_time",
        }
    ]

    tableColumn = [{
        title: '工号',
        dataIndex: 'job_number',
        key: 'job_number',
        className: 'table-global-head-small'
    }, {
        title: '员工姓名',
        dataIndex: 'real_name',
        key: 'real_name',
        className: 'table-global-head-small'
    }, {
        title: '英文名',
        dataIndex: 'english_name',
        key: 'english_name',
        className: 'table-global-head-small'
    }, {
        title: '部门',
        dataIndex: 'department_name',
        key: 'department_name',
        className: 'table-global-head-small'
    }, {
        title: '未交次数',
        dataIndex: 'no_count',
        key: 'no_count',
        className: 'table-global-head-small'
    }, {
        title: '晚交次数',
        dataIndex: 'late_count',
        key: 'late_count',
        className: 'table-global-head-small'
    }, {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        className: 'table-global-head-small',
        render: (text, record, index) => (
            <DynamicButton column={this.buttonColumn(text, record, index)}
                module={this.childModuleName}
                access={this.props.access} />
        )
    }
    ]

    detailTableColumn = [{
        title: '报告时间周',
        dataIndex: 'report_date_str',
        key: 'report_date_str',
        className: 'table-global-head-small'
    }, {
        title: '工号',
        dataIndex: 'job_number',
        key: 'job_number',
        className: 'table-global-head-small'
    }, {
        title: '员工姓名',
        dataIndex: 'real_name',
        key: 'real_name',
        className: 'table-global-head-small'
    }, {
        title: '英文名',
        dataIndex: 'english_name',
        key: 'english_name',
        className: 'table-global-head-small'
    }, {
        title: '部门',
        dataIndex: 'department_name',
        key: 'department_name',
        className: 'table-global-head-small'
    }, {
        title: '状态',
        dataIndex: 'status_str',
        key: 'status_str',
        className: 'table-global-head-small'
    }, {
        title: '处理结果',
        dataIndex: 'handle_result_str',
        key: 'handle_result_str',
        className: 'table-global-head-small'
    }, {
        title: '操作',
        dataIndex: 'actions',
        key: 'actions',
        className: 'table-global-head-small',
        render: (text, record, index) => (
            <DynamicButton column={this.detailButtonColumn(text, record, index)}
                module={this.childModuleName}
                access={this.props.access} />
        )
    }
    ]

    buttonColumn = (text, record, index) => [{
        size: "small",
        type: "default",
        icon: "edit",
        title: "查看",
        access: "u_value",
        click: this.updateData.bind(this, record, index),
    }]
    detailButtonColumn = (text, record, index) => [{
        size: "small",
        type: "default",
        icon: "delete",
        title: "删除",
        access: "d_value",
        click: this.deleteData.bind(this, record, index),
    }]

    updateData = (record, index) => this.setState({
        currentModalStatus: true,
        currentDataStatus: "loading",
        currentIndex: index
    }, () => {
        let gets = {
            employee_id: record.employee_id,
            search_start_time: record.start_date,
            search_end_time: record.end_date,
            report_type: 2,
            search_all: true
        };
        this.setState({ currentDataFilters: gets })
        this.fetchHRWorkReportExceptionStatisticsList(gets)
    })
    deleteData = (record, index) => {
        Modal.confirm({
            title: '确定删除选中的内容么?',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                let data = {
                    ids: [record.id]
                };
                dailyReportrexceptionDtatisticsService
                    .deleteHRWorkReportExceptionStatistics(data, res => {
                        if (res.data.Success) {
                            message.success('删除操作成功', 4);
                            this.fetchHRWorkReportExceptionStatisticsList(this.state.currentDataFilters)
                            this.publicSelect()
                        } else {
                            message.error('删除操作失败' + res.data.Errors[0], 4);
                        }
                    }, err => message.error('删除操作失败, 请联系管理员'));
            },
            onCancel: () => { }
        });

    }

    fetchHRWorkReportExceptionStatisticsList = (gets) => {
        dailyReportrexceptionDtatisticsService
            .fetchHRWorkReportExceptionStatisticsList(gets, res => {
                if (res.data.Success || res.data.Success === undefined) {
                    this.setState({
                        currentDataStatus: "loaded",
                        currentData: this.dataMode === 1 ? res.data.Object : res.data
                    })
                }
                else {
                    message.error(res.data.Message)
                    this.setState({
                        currentDataStatus: "loaded",
                    })
                }
            })
    }

    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }

    //#region publicChange(更改条件后不会触发查询)
    publicChange = (filters) => this.setState({
        filters: {
            ...this.state.filters,
            ...filters,
        }
    })
    //#endregion

    setNameFilter = value => {
        this.setState({
            filters: {
                ...this.state.filters,
                employee_info: value,
                page: 1
            }
        }, this.publicSelect)
    }

    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <DynamicButton column={this.headerColumn}
                        module={this.childModuleName}
                        access={this.props.access} />
                    <div className="colAction"
                        style={{ float: "right", margin: "0px 10px 10px 0px" }}>
                        <Input.Search
                            placeholder="请输入工号或姓名"
                            onSearch={this.setNameFilter}
                            style={{ width: 200 }}
                            enterButton />
                    </div>
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <Modal width="900px"
                    maskClo sable={false}
                    visible={this.state.currentModalStatus}
                    title="查看"
                    destroyOnClose={true}
                    onCancel={this.toggleCurrentModal}
                    footer={<Button type="back" onClick={this.toggleCurrentModal}>关闭</Button>}>
                    <DynamicTable column={this.detailTableColumn}
                        dataStatus={this.dataSource().currentDataStatus}
                        dataSource={this.dataSource().currentData.Data}
                        pagination={false} />
                </Modal>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize,
                            current: this.dataSource().filters.page
                        }}
                        setPageFilter={this.publicChangeForSelect} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
    }
}
const mapDispatchToProps = {
    fetchDepartmentsList,
}
NoDeliveryWeeklyReport = connect(mapStateToProps, mapDispatchToProps)(Form.create()(NoDeliveryWeeklyReport));



// WEBPACK FOOTER //
// ./src/routes/WorkReport/NoDeliveryWeeklyReport.js